{
  "auth": {
    "agree": "J'accepte",
    "createAccount": "Créer un compte",
    "createNewAccount": "Créer un nouveau compte",
    "email": "E-mail",
    "login": "Se connecter",
    "password": "Mot de passe",
    "recover_password": "Récupérer le mot de passe",
    "sign_up": "S'inscrire",
    "keep_logged_in": "Rester connecté",
    "termsOfUse": "Conditions d'utilisation.",
    "reset_password": "Réinitialiser le mot de passe"
  },
  "404": {
    "title": "Cette page est introuvable.",
    "text": "Si vous pensez que cela est incorrect, veuillez nous envoyer un message à ",
    "back_button": "Retour au tableau de bord"
  },
  "typography": {
    "primary": "Styles de texte principal",
    "secondary": "Styles de texte secondaire"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Configurer les connexions à distance",
    "currentVisitors": "Visiteurs actuels",
    "navigationLayout": "Disposition de navigation",
    "topBarButton": "Barre supérieure",
    "sideBarButton": "Barre latérale"
  },
  "language": {
    "brazilian_portuguese": "Portugais",
    "english": "Anglais",
    "spanish": "Espagnol",
    "simplified_chinese": "Chinois simplifié",
    "persian": "Persan"
  },
  "menu": {
    "auth": "Authentification",
    "buttons": "Boutons",
    "timelines": "Chronologies",
    "dashboard": "Tableau de bord",
    "billing": "Facturation",
    "login": "Connexion",
    "preferences": "Préférences du compte",
    "payments": "Paiements",
    "settings": "Paramètres généraux",
    "pricing-plans": "Plans tarifaires",
    "payment-methods": "Moyens de paiement",
    "signup": "Inscription",
    "recover-password": "Récupération du mot de passe",
    "recover-password-email": "E-mail de récupération",
    "404": "404",
    "faq": "FAQ",
    "users": "Utilisateurs",
    "files": "Fiches pédagogiques",
    "mandatory": "Affichage obligatoire"
  },
  "messages": {
    "all": "Voir tous les messages",
    "new": "Nouveaux messages de {name}",
    "mark_as_read": "Marquer comme lu"
  },
  "navbar": {
    "messageUs": "Demandes de développement web :",
    "repository": "Dépôt GitHub"
  },
  "notifications": {
    "all": "Voir toutes les notifications",
    "less": "Voir moins de notifications",
    "mark_as_read": "Marquer comme lu",
    "sentMessage": "vous a envoyé un message",
    "uploadedZip": "a téléchargé un nouveau fichier Zip avec {type}",
    "startedTopic": "a démarré un nouveau sujet"
  },
  "user": {
    "language": "Changer de langue",
    "logout": "Se déconnecter",
    "profile": "Profil",
    "settings": "Paramètres",
    "billing": "Facturation",
    "faq": "FAQ",
    "helpAndSupport": "Aide & support",
    "files": "Fiches pédagogiques",
    "mandatory": "Affichage obligatoire",
    "account": "Compte",
    "explore": "Explorer"
  },
  "treeView": {
    "basic": "Basique",
    "icons": "Icônes",
    "selectable": "Sélectionnable",
    "editable": "Modifiable",
    "advanced": "Avancé"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Envoyer"
  },
  "spacingPlayground": {
    "value": "Valeur",
    "margin": "Marge",
    "padding": "Rembourrage"
  },
  "spacing": {
    "title": "Espacement"
  },
  "cards": {
    "cards": "Cartes",
    "fixed": "Fixe",
    "floating": "Flottant",
    "contentText": "Les rayures uniques des zèbres les rendent parmi les animaux les plus familiers.",
    "contentTextLong": "Les rayures uniques des zèbres les rendent parmi les animaux les plus familiers. Ils vivent dans divers habitats tels que les prairies, les savanes, les bois, les broussailles, les montagnes et les collines côtières. Divers facteurs anthropiques ont eu un impact sévère sur les populations de zèbres, notamment la chasse pour leur peau et la destruction de leur habitat. Le zèbre de Grévy et le zèbre des montagnes sont en danger. Les zèbres des plaines sont beaucoup plus nombreux, mais une sous-espèce, le quagga, a disparu.",
    "rowHeight": "Hauteur des rangées",
    "title": {
      "default": "Par défaut",
      "withControls": "Avec contrôles",
      "customHeader": "En-tête personnalisé",
      "withoutHeader": "Sans en-tête",
      "withImage": "Avec image",
      "withTitleOnImage": "Avec titre sur l'image",
      "withCustomTitleOnImage": "Avec titre personnalisé sur l'image",
      "withStripe": "Avec bande",
      "withBackground": "Avec arrière-plan"
    },
    "button": {
      "main": "Principal",
      "cancel": "Annuler",
      "showMore": "Voir plus",
      "readMore": "Lire la suite"
    },
    "link": {
      "edit": "Modifier",
      "setAsDefault": "Définir comme défaut",
      "delete": "Supprimer",
      "traveling": "Voyage",
      "france": "France",
      "review": "Avis",
      "feedback": "Donner un avis",
      "readFull": "Lire l'article complet",
      "secondaryAction": "Action secondaire",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Couleurs du thème",
    "extraColors": "Couleurs supplémentaires",
    "gradients": {
      "basic": {
        "title": "Dégradés des boutons"
      },
      "hovered": {
        "title": "Dégradés au survol des boutons",
        "text": "Éclaircir de 15 % appliqué à un style original (dégradé ou couleur plate) pour l'état survolé."
      },
      "pressed": {
        "title": "Dégradés des boutons pressés",
        "text": "Assombrir de 15 % appliqué à un style original (dégradé ou couleur plate) pour l'état pressé."
      }
    }
  },
  "tabs": {
    "alignment": "Alignement des onglets",
    "overflow": "Débordement des onglets",
    "hidden": "Onglets avec curseur caché",
    "grow": "Agrandissement des onglets"
  },
  "helpAndSupport": "Aide & support",
  "aboutVuesticAdmin": "À propos de Vuestic Admin",
  "supportAndConsulting": "Support & Conseil",
  "search": {
    "placeholder": "Rechercher..."
  },
  "buttonSelect": {
    "dark": "Sombre",
    "light": "Clair"
  },
  "vuestic": {
    "search": "Rechercher",
    "noOptions": "Aucun élément trouvé",
    "ok": "OK",
    "cancel": "Annuler",
    "uploadFile": "Téléverser un fichier",
    "undo": "Annuler",
    "dropzone": "Déposez les fichiers ici pour téléverser",
    "fileDeleted": "Fichier supprimé",
    "closeAlert": "fermer l'alerte",
    "backToTop": "retour en haut",
    "toggleDropdown": "basculer le menu déroulant",
    "carousel": "carrousel",
    "goPreviousSlide": "aller à la diapositive précédente",
    "goNextSlide": "aller à la diapositive suivante",
    "goSlide": "aller à la diapositive {index}",
    "slideOf": "diapositive {index} sur {length}",
    "close": "fermer",
    "openColorPicker": "ouvrir le sélecteur de couleurs",
    "colorSelection": "sélection de couleur",
    "colorName": "couleur {color}",
    "decreaseCounter": "diminuer le compteur",
    "increaseCounter": "augmenter le compteur",
    "selectAllRows": "sélectionner toutes les lignes",
    "sortColumnBy": "trier la colonne par {name}",
    "selectRowByIndex": "sélectionner la ligne {index}",
    "resetDate": "réinitialiser la date",
    "nextPeriod": "période suivante",
    "switchView": "changer de vue",
    "previousPeriod": "période précédente",
    "removeFile": "supprimer le fichier",
    "reset": "réinitialiser",
    "pagination": "pagination",
    "goToTheFirstPage": "aller à la première page",
    "goToPreviousPage": "aller à la page précédente",
    "goToSpecificPage": "aller à la page {page}",
    "goToSpecificPageInput": "entrez le numéro de page",
    "goNextPage": "aller à la page suivante",
    "goLastPage": "aller à la dernière page",
    "currentRating": "note actuelle {value} sur {max}",
    "voteRating": "votez pour la note {value} sur {max}",
    "optionsFilter": "filtrer les options",
    "splitPanels": "diviser les panneaux",
    "movePaginationLeft": "déplacer la pagination vers la gauche",
    "movePaginationRight": "déplacer la pagination vers la droite",
    "resetTime": "réinitialiser l'heure",
    "closeToast": "fermer la notification",
    "selectedOption": "Option sélectionnée",
    "noSelectedOption": "Aucune option sélectionnée",
    "breadcrumbs": "fil d'Ariane",
    "counterValue": "valeur du compteur",
    "selectedDate": "date sélectionnée",
    "selectedTime": "heure sélectionnée",
    "progressState": "état de progression",
    "color": "couleur",
    "next": "Suivant",
    "back": "Précédent",
    "finish": "Terminer",
    "step": "étape",
    "progress": "progression",
    "loading": "Chargement",
    "sliderValue": "Valeur actuelle du curseur : {value}",
    "switch": "Interrupteur",
    "inputField": "Champ de saisie",
    "fileTypeIncorrect": "Type de fichier incorrect",
    "select": "Sélectionnez une option"
  }
}
